import templateUrl from './dashboard-container.html'

export const DashboardContainerComponent = {
    bindings: {
        include: "<",
        exclude: "<"
    },
    controllerAs: "vm",
    templateUrl,
    controller: function DashboardController($q, dashboardService, $scope) {
        'ngInject'
        const vm = this;

        vm.$onInit = $onInit;
        vm.dashboards = [];
        // Shared payroll data for injecting into directive components.
        vm.payrolls = [];
        vm.loaded = false;
        vm.dashboardsLoaded = false;

        ////////

        $scope.$watch('vm.dashboards', function (newValue, oldValue) {
            if (newValue !== oldValue && !vm.dashboardsLoaded) {
                vm.dashboardsLoaded = newValue.every(item => item.loaded);
            }
            
        }, true);


        function $onInit() {
            dashboardService.retrieveDashboards(vm.include, vm.exclude)
                .then(function (dashboards) {
                    vm.dashboards = dashboards;
                })
                .catch(function(ex) {
                    console.error(ex)
                })
                .then(function() {
                    vm.loaded = true;
                });
        }
    }
}
